<ng-template #postEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ postForm.get('blog_id').value ? 'Edit' : 'Add' }} Blog Post</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<form [formGroup]="postForm" *ngIf="postForm" class="blog-form">
			<div class="row">
				<div class="col-md-6 col-sm-12">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Title</mat-label>
						<input matInput required formControlName="title">
					</mat-form-field>
				</div>
				<div class="col-md-6 col-sm-12">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Author</mat-label>
						<input matInput required formControlName="author">
					</mat-form-field>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4 col-sm-12">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Status</mat-label>
						<mat-select formControlName="status">
							<mat-option *ngFor="let st of statuses" [value]="st.value">{{ st.label }}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-md-4 col-sm-12">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Sort Order</mat-label>
						<input matInput type="number" formControlName="sort_order">
					</mat-form-field>
				</div>
				<div class="col-md-4 col-sm-12 d-flex align-items-center">
					<mat-slide-toggle formControlName="allow_comments">Allow Comments</mat-slide-toggle>
				</div>
			</div>

			<div class="row" *ngIf="categories && categories.length">
				<div class="col-12">
					<label class="category-label">Categories</label>
					<div class="category-list">
						<label class="category-checkbox" *ngFor="let category of categories">
							<input type="checkbox" [checked]="isCategorySelected(category.blog_category_id)" (change)="toggleCategory(category.blog_category_id, $event)">
							{{ category.name }}
						</label>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<label class="category-label">Image</label>
					<div class="row image-upload-row">
						<div class="col-auto" *ngIf="postForm.get('image').value">
							<div class="thumbnail-container">
								<img [src]="postForm.get('image').value" class="img-thumbnail thumbnail">
							</div>
						</div>
						<div class="col">
							<ngx-dropzone [multiple]="false" (change)="onImageSelect($event)">
								<ngx-dropzone-label>Drop an image here or click to upload</ngx-dropzone-label>
								<ngx-dropzone-image-preview *ngFor="let f of uploadedImages" [file]="f" [removable]="true" (removed)="onImageRemove()"></ngx-dropzone-image-preview>
							</ngx-dropzone>
							<div class="text-muted uploading-note" *ngIf="uploadingImage">Uploading&hellip;</div>
						</div>
						<div class="col-auto" *ngIf="postForm.get('image').value">
							<button mat-icon-button color="warn" type="button" (click)="onImageRemove()"><mat-icon>delete</mat-icon></button>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<label class="category-label">Description</label>
					<app-wysiwyg-editor [input]="{value: postForm.get('description').value}" [config]="'limited'" [inModal]="true" (data)="onDescriptionChange($event)"></app-wysiwyg-editor>
				</div>
			</div>

			<div class="row seo-fields">
				<div class="col-md-4 col-sm-12">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Meta Title</mat-label>
						<input matInput formControlName="meta_title">
					</mat-form-field>
				</div>
				<div class="col-md-4 col-sm-12">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Meta Description</mat-label>
						<input matInput formControlName="meta_description">
					</mat-form-field>
				</div>
				<div class="col-md-4 col-sm-12">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Meta Keywords</mat-label>
						<input matInput formControlName="meta_keyword">
					</mat-form-field>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button mat-raised-button color="primary" [disabled]="saving" (click)="savePost()">{{ saving ? 'Saving...' : 'Save Post' }}</button>
	</div>
</ng-template>

<ng-template #confirmDeleteModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="modal-title">Confirm Blog Post Deletion</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="cancelDelete(modal)">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>Are you sure you want to delete this blog post?</p>
		<div class="alert alert-warning">
			<strong>Title:</strong> {{ pendingDeletePost?.title }}
		</div>
		<p class="text-danger">This action cannot be undone.</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="cancelDelete(modal)">Cancel</button>
		<button type="button" class="btn btn-danger" (click)="handleConfirmDelete(modal)">Delete</button>
	</div>
</ng-template>

<button mat-stroked-button color="success" aria-label="" (click)="createPost()" class="mt-2 mb-2">
	<mat-icon>add</mat-icon> Add Blog Post
</button>

<div *ngIf="posts === false" class="text-muted loading-note">Loading blog posts&hellip;</div>

<div *ngIf="posts && posts.length === 0" class="text-muted empty-note">There are no blog posts yet.</div>

<div class="table-responsive" *ngIf="posts && posts.length">
	<table class="table table-striped table-hover table-bordered blog-table">
		<thead class="thead-dark">
			<tr>
				<th scope="col">ID</th>
				<th scope="col">Title</th>
				<th scope="col">Author</th>
				<th scope="col">Status</th>
				<th scope="col">Date Added</th>
				<th scope="col" class="text-center">Edit/Remove</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let post of posts">
				<td data-label="ID">{{ post.blog_id }}</td>
				<td data-label="Title">{{ post.title }}</td>
				<td data-label="Author">{{ post.author }}</td>
				<td data-label="Status">{{ (+post.status) ? 'Published' : 'Draft' }}</td>
				<td data-label="Date Added">{{ post.date_added }}</td>
				<td data-label="Edit/Remove" class="text-center">
					<button mat-icon-button color="primary" (click)="editPost(post)"><mat-icon>edit</mat-icon></button>
					&nbsp;&nbsp;
					<button mat-icon-button color="warn" (click)="confirmDeletePost(post)"><mat-icon>delete</mat-icon></button>
				</td>
			</tr>
		</tbody>
	</table>
</div>
